import { Outlet } from '@tanstack/react-router';

import { DevTools } from '@/core/dev-tools';

export function Root() {
  return (
    <>
      <Outlet />

      <DevTools />
    </>
  );
}
